import Vue from 'vue';
import { i18n } from '@/plugins/vue-i18n';
import { chip, entityIcon, tooltip } from '@/modules/list/config/utils';


export function formatAdPosition(adPosition) {
  let slotLabel = null;
  if (adPosition.slot) {
    slotLabel = i18n.te(`message.advertising.slots.${adPosition.slot}`)
      ? i18n.t(`message.advertising.slots.${adPosition.slot}`)
      : adPosition.slot;
  }
  return {
    id: adPosition.id,
    title: adPosition.name,
    icon: {
      name: entityIcon('adPosition'),
    },
    type: adPosition.type || 'adPosition',
    editor: 'entity',
    chips: [
      tooltip(chip(slotLabel), i18n.t('message.advertising.slot')),
      tooltip(
        chip(adPosition.modificationDate ? Vue.filter('formatDate')(adPosition.modificationDate) : null),
        i18n.t('message.metadata.modificationDate'),
      ),
      tooltip(
        chip(adPosition.creationDate ? Vue.filter('formatDate')(adPosition.creationDate) : null),
        i18n.t('message.metadata.creationDate'),
      ),
      chip(!adPosition.active ? i18n.t('message.searcher.filters.values.state.inactive') : null),
    ].filter(c => !!c.value),
  };
}

export function formatAdMap(adMap) {
  return {
    id: adMap.id,
    title: adMap.name,
    icon: {
      name: entityIcon('adMap'),
    },
    type: adMap.type || 'adMap',
    editor: 'entity',
    chips: [
      tooltip(chip(i18n.t(`message.advertising.maps.${adMap.type}`)), i18n.t('message.metadata.type')),
      tooltip(
        chip(adMap.modificationDate ? Vue.filter('formatDate')(adMap.modificationDate) : null),
        i18n.t('message.metadata.modificationDate'),
      ),
      tooltip(
        chip(adMap.creationDate ? Vue.filter('formatDate')(adMap.creationDate) : null),
        i18n.t('message.metadata.creationDate'),
      ),
      chip(!adMap.active ? i18n.t('message.searcher.filters.values.state.inactive') : null),
    ].filter(c => !!c.value),
  };
}
